import { COLOR_KEYS } from 'legacyfrontend/constants';
import { useSelector } from 'react-redux';
import { selectColors } from 'legacyfrontend/redux/selectors/application-selectors';
import { useMemo } from 'react';

export const useColors = () => {
  const colors = useSelector(selectColors);

  return useMemo(
    () => ({
      background: colors?.background || COLOR_KEYS.DEFAULT_BACKGROUND,
      defaultBackground: COLOR_KEYS.DEFAULT_BACKGROUND,
      text: colors?.text || COLOR_KEYS.DEFAULT_TEXT,
      gray: colors?.gray || COLOR_KEYS.DEFAULT_COLOR_GRAY,
      coral: COLOR_KEYS.CORAL,
      selected: {
        background:
          colors?.selected?.background || colors?.background || COLOR_KEYS.DEFAULT_BACKGROUND,
        text: colors?.selected?.text || colors?.text || COLOR_KEYS.DEFAULT_TEXT,
      },
      selected2: {
        background:
          colors?.selected2?.background || colors?.background || COLOR_KEYS.DEFAULT_BACKGROUND,
        text: colors?.selected2?.text || colors?.text || COLOR_KEYS.DEFAULT_TEXT,
      },
    }),
    [colors]
  );
};
